import React, { Component } from 'react';
import SimplePage from '../SimplePage';
import { Form, Input, Select, FormRow } from '../Forms';
import AjaxInProgressHOC from '../AjaxInProgressHOC';
import setViewTitle from '../../../helpers/setViewTitle';
import request from '../../../helpers/request';
import appConfig from '../../../config/appConfig';

class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      name: '',
      sendNotifications: true,
      notificationEmail: ''
    };
  }

  submitForm(profile) {
    console.log(this.state);

    request.put({
      url: appConfig.apiUrl + 'user/profile',
      data: profile,
      success: () => {
        this.props.history.push(`/`);
      }
    });
  }

  componentWillMount() {
    setViewTitle('Benutzerprofil');
  }

  componentDidMount() {
    request.get({
      url: appConfig.apiUrl + 'user/profile',
      success: profile => {
        this.setState(profile);
      }
    });
  }

  render() {
    return (
      <SimplePage title="Benutzerprofil" icon="user" actions={this.actions}>
        <Form ref={c => this.form = c}
          onSubmit={this.submitForm}
          isAjaxInProgress={this.props.isAjaxInProgress}
          backButtonLink={''}>

          <fieldset>
            <FormRow width={6}>
              <Input
                layout="vertical"
                name="name"
                id="name"
                label="Name:"
                type="text"
                value={this.state.name}
                required
              />
            </FormRow>

            <FormRow width={6}>
              <Input
                layout="vertical"
                name="email"
                id="email"
                label="Email für Login:"
                type="text"
                value={this.state.email}
                disabled
              />
            </FormRow>

            <FormRow width={6}>
              <Input
                layout="vertical"
                name="notificationEmail"
                id="notificationEmail"
                label="Email für Benachrichtigungen:"
                type="text"
                value={this.state.notificationEmail}
                required
              />
            </FormRow>

            <FormRow width={6}>
              <Select
                layout="vertical"
                name="sendNotifications"
                id="sendNotifications"
                label="Benachrichtigungen senden?:"
                options={[{value: true, label: 'Ja'}, {value: false, label: 'Nein'}]}
                value={this.state.sendNotifications}
                />
            </FormRow>

          </fieldset>
        </Form>
      </SimplePage>
    );
  }
}

export default AjaxInProgressHOC(Profile);



// WEBPACK FOOTER //
// ./src/components/common/User/Profile.js